import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@morningtrain/react-navigation'

function Breadcrumb ({ children, text, route, parameters = {}, active }) {
  return (
    <div className='breadcrumb'>
      <Link route={route} parameters={parameters} className={'text-sm whitespace-no-wrap text-gray-400 hover:text-primary-500' + (active ? ' text-primary-900' : '')}>
        {text || children}
      </Link>
    </div>
  )
}

Breadcrumb.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  route: PropTypes.string,
  parameters: PropTypes.object
}

export default Breadcrumb
